export function useQualityTranslation(quality, t) {
  return t(`Quality.${quality}`);
}
